import { createFileRoute, redirect } from '@tanstack/react-router';
import { getAuthStore } from '../main';
import { AccountTabs } from '../components/AccountTabs';
import { SpSidebar } from '../components/Sidebar';
import { Pane } from '@sheridan-prize/ui';

export const Route = createFileRoute('/account')({
  beforeLoad: async () => {
    await getAuthStore().fetchUser();
    const isAuthenticated = getAuthStore().getIsAuthenticated();
    const userRole = getAuthStore().getUser()?.role;

    if (!isAuthenticated) {
      throw redirect({ to: '/login' });
    }

    if (userRole !== 'superadmin' && userRole !== 'admin') {
      throw redirect({ to: '/' });
    }

    await getAuthStore().fetchUserDoc();
  },
  component: AdminAccount,
});

function AdminAccount() {
  return (
    <>
      <SpSidebar />
      <Pane classes={'sp-main'} tag="main">
        <h1>Your Account</h1>
        <AccountTabs />
      </Pane>
    </>
  );
}
